import routerOptions0 from "/home/runner/work/web/web/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@22.8.7_ioredis@5.4.1_magicast@0.3.5_rollup@4._j4egxepaneljta5y3h5vwa52vm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}